import { CapoPlugin } from "/home/node/app/node_modules/.pnpm/@unhead+vue@1.10.4_vue@3.5.0_typescript@4.9.5_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];